import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CheckCircle2, XCircle, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaFinalizada = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('finalizou demanda com aceite') || 
           acaoLower.includes('finalizou demanda com recusa') ||
           acaoLower === 'demanda finalizada';
};

const getIconDemandaFinalizada = (acao: string): { Icon: LucideIcon; color: string } => {
    const acaoLower = acao.toLowerCase().trim();
    if (acaoLower.includes('aceite') || acaoLower === 'demanda finalizada') {
        return { Icon: CheckCircle2, color: 'var(--c16a34a)' };
    }
    return { Icon: XCircle, color: 'var(--cdc2626)' };
};

export default function CardDemandaFinalizada({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaFinalizada(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const demandaFinalizadaConfig = {
    tipo: 'demanda_finalizada',
    detectaTipo: detectaDemandaFinalizada,
    getIcon: getIconDemandaFinalizada,
    temExpansao: () => true,
    Component: CardDemandaFinalizada
};

